const _import = name => {
  return resolve => require([`../../views/${name}`], resolve)
}

const teamChild = {
  path: '/team',
  component: _import('team'),
  children: [
    {
      path: '',
      redirect: 'affiliate'
    },
    {
      meta: { navShow: true, requireAuth:true, titleHide: true, title: '团队'},
      path: 'promotion',
      name: 'TeamPromotion',
      component: _import('team/Base'),
    },
    {
      meta: { navShow: true, requireAuth:false, titleHide: true, bgStyle1: true, title: '代理介绍'},
      path: 'affiliate',
      name: 'Affiliate',
      component: _import('team/affiliate/index2'),
    },
    {
      meta: { navShow: false, requireAuth:true, titleHide: true, title: '佣金提取记录'},
      path: 'commission-withdrawal-record',
      name: 'withdrawalRecord',
      component: _import('team/withdrawal-record'),
    },
    {
      meta: { navShow: false, requireAuth:true, titleHide: true, title: '推广教程'},
      path: 'promotion-tutorial',
      name: 'promotionTutorial',
      component: _import('team/promotion/tutorial'),
    },
	{
	  meta: { navShow: false, requireAuth:true, titleHide: true, title: '推广视频教程'},
	  path: 'tutorial-video',
	  name: 'tutorialVideo',
	  component: _import('team/videos'),
	},
    
    {
      meta: { navShow: false, requireAuth:true, titleHide: true, title: '业绩查询'},
      path: 'performance',
      name: 'Performance',
      component: _import('team/performance'),
    },
    {
      meta: { navShow: false, requireAuth:true, titleHide: true, title: '业绩详情'},
      path: 'performance-details',
      name: 'PerformanceDetails',
      component: _import('team/performance/details'),
    },
    {
      meta: { navShow: false, requireAuth:true, titleHide: true, title: '返佣比例'},
      path: 'performance-rebate-ratio',
      name: 'RebateRatio',
      component: _import('team/performance/rebate-ratio'),
    },

    {
      meta: { navShow: false, requireAuth:true, titleHide: true, title: '直属查询'},
      path: 'directly',
      name: 'Directly',
      component: _import('team/directly'),
    },
    {
      meta: { navShow: false, requireAuth:true, titleHide: true, title: '团队查询'},
      path: 'group',
      name: 'Group',
      component: _import('team/group'),
    }
  ]
}
export default teamChild



// WEBPACK FOOTER //
// ./src/pages/build902/router/module/Team.js